/*
 * @Author: Claude
 * @Date: 2025-11-11
 * @Description: Text to Image Store
 */

import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { createWithEqualityFn } from 'zustand/traditional';

import baseConfig from '@/config';

const key = 'f_text_to_image_state';

type TextToImageState = {
  formValues: {
    [key: string]: any;
  };
  setFormValues: (values: Partial<TextToImageState['formValues']>) => void;
  reset: () => void;
};

const initialData: TextToImageState['formValues'] = {};

export const useTextToImageStore = createWithEqualityFn<TextToImageState>()(
  devtools(
    persist(
      (set) => ({
        formValues: initialData,
        setFormValues: (values: Partial<TextToImageState['formValues']>) =>
          set((state) => ({ formValues: { ...state.formValues, ...values } })),
        reset: () => {
          set({ formValues: { ...initialData } });
        },
      }),
      {
        name: key,
        storage: createJSONStorage(() => localStorage),
        partialize: ({ formValues }) => ({
          formValues,
        }),
      },
    ),
    {
      name: key,
      enabled: baseConfig.debuggable,
    },
  ),
);
